var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_48539",
    "data-name": "Group 48539",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.964,
    height: 18.051,
    viewBox: "0 0 17.964 18.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_39",
    "data-name": "Subtraction 39",
    d: "M.457,18.051h0v-.087A.456.456,0,0,1,0,17.457L.55,12.482a.459.459,0,0,1,.133-.274L12.28.595a2.009,2.009,0,0,1,2.855,0l2.236,2.21a2.018,2.018,0,0,1,0,2.86L5.749,17.279a.461.461,0,0,1-.273.132l-4.958.553H.458ZM13.71.916a1.1,1.1,0,0,0-.782.323L1.444,12.737.974,16.992l4.248-.471L16.7,5.015a1.12,1.12,0,0,0,0-1.566L14.492,1.238A1.1,1.1,0,0,0,13.71.916Z",
    transform: "translate(0 0)",
    fill: "#f45e29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M-.119,4.828a.379.379,0,0,1-.269-.111.381.381,0,0,1,0-.538L4.179-.389a.381.381,0,0,1,.538,0,.381.381,0,0,1,0,.538L.15,4.717A.379.379,0,0,1-.119,4.828Z",
    transform: "translate(5.676 7.934)",
    fill: "#f45e29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_70",
    "data-name": "Line 70",
    d: "M3.452,3.991-.354.185.185-.354,3.991,3.452Z",
    transform: "translate(10.97 3.332)",
    fill: "#f45e29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.2be07674.svg";
export { ForwardRef as ReactComponent };